var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pb-4 align-stretch",attrs:{"height":"100%","loading":_vm.loading}},[_c('v-card-title',[_vm._t("title")],2),(!_vm.loading)?_c('v-card-text',[_vm._t("content")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }